import {
  Box,
  Flex,
  FormControl,
  FormErrorMessage,
  Grid,
  GridItem,
  RadioGroup,
  Stack,
  Text,
} from "@chakra-ui/react";
import { Field } from "formik";
import { RadioButtonField } from "../../../../../components/RadioButtonField";

export const ProgramaApadrinhementoAba = ({ children, props }) => {
  return (
    <>
      <Flex mb={4} justifyContent={"space-between"}>
        <Text
          fontWeight={700}
          fontSize="16px"
          lineHeight="21.6px"
          color={"#575553"}
        >
          Programa de Apadrinhamento
        </Text>
        {children}
      </Flex>

      <Box>
        <Text
          color="#5F6377"
          fontWeight="500"
          fontSize="14px"
          lineHeight="19.6px"
          htmlFor={"Está incluído (a) no Programa de Apadrinhamento?"}
          mb={4}
          mt={7}
        >
          Está incluído (a) no Programa de Apadrinhamento?
        </Text>
        <Grid
          templateColumns="repeat(15, 1fr)"
          gap="15px"
          mt="15px"
          w="100%"
          alignItems={"center"}
        >
          <GridItem colSpan={{ base: 9, "2xl": 7 }}>
            <Field name="radioIncluidoPrograma">
              {({ field, form }) => (
                <FormControl
                  isInvalid={
                    form.errors.radioIncluidoPrograma &&
                    form.touched.radioIncluidoPrograma
                  }
                  id="radioIncluidoPrograma"
                  width="max-content"
                  zIndex={"1"}
                >
                  <RadioGroup
                    value={field.value}
                    onChange={(value) =>
                      props.setFieldValue("radioIncluidoPrograma", value)
                    }
                  >
                    <Stack direction="row" gap={4}>
                      <RadioButtonField
                        id="radio-incluidoPrograma-s"
                        fieldName="radioIncluidoPrograma"
                        value="S"
                        label="Sim"
                      />
                      <RadioButtonField
                        id="radio-incluidoPrograma-n"
                        fieldName="radioIncluidoPrograma"
                        value="N"
                        label="Não"
                      />

                      <RadioButtonField
                        id="radio-incluidoPrograma-si"
                        fieldName="radioIncluidoPrograma"
                        value="SI"
                        label="Sem Informação"
                      />
                    </Stack>
                  </RadioGroup>
                  <FormErrorMessage mt="-1" mr="-16">
                    {form.errors.radioIncluidoPrograma}
                  </FormErrorMessage>
                </FormControl>
              )}
            </Field>
          </GridItem>
        </Grid>
      </Box>
      <Box>
        <Text
          color="#5F6377"
          fontWeight="500"
          fontSize="14px"
          lineHeight="19.6px"
          htmlFor={"Está sendo Apadrinhado?"}
          mb={4}
          mt={7}
        >
          Está sendo Apadrinhado?
        </Text>
        <Grid
          templateColumns="repeat(15, 1fr)"
          gap="15px"
          mt="15px"
          w="100%"
          alignItems={"center"}
        >
          <GridItem colSpan={{ base: 9, "2xl": 7 }}>
            <Field name="radioSendoApadrinhado">
              {({ field, form }) => (
                <FormControl
                  isInvalid={
                    form.errors.radioSendoApadrinhado &&
                    form.touched.radioSendoApadrinhado
                  }
                  id="radioSendoApadrinhado"
                  width="max-content"
                  zIndex={"1"}
                >
                  <RadioGroup
                    value={field.value}
                    onChange={(value) =>
                      props.setFieldValue("radioSendoApadrinhado", value)
                    }
                  >
                    <Stack direction="row" gap={4}>
                      <RadioButtonField
                        id="radio-sendoapadrinhado-s"
                        fieldName="radioSendoApadrinhado"
                        value="S"
                        label="Sim"
                        disabled={props.values.radioIncluidoPrograma !== "S"}
                      />
                      <RadioButtonField
                        id="radio-sendoapadrinhado-n"
                        fieldName="radioSendoApadrinhado"
                        value="N"
                        label="Não"
                        disabled={props.values.radioIncluidoPrograma !== "S"}
                      />
                      <RadioButtonField
                        id="radio-sendoapadrinhado-n"
                        fieldName="radioSendoApadrinhado"
                        value="SI"
                        label="Sem Informação"
                        disabled={props.values.radioIncluidoPrograma !== "S"}
                      />
                    </Stack>
                  </RadioGroup>
                  <FormErrorMessage mt="-1" mr="-16">
                    {form.errors.radioSendoApadrinhado}
                  </FormErrorMessage>
                </FormControl>
              )}
            </Field>
          </GridItem>
        </Grid>
      </Box>
    </>
  );
};
